// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-light: #f4f9ff;
  --color-white: #ffffff;
  --color-primary: #1f68d6;
  --color-primary-2: #3b7ee3;
  --color-primary-3: #ccedff;
  --color-primary-4: #003c97;
  --color-primary-7: #c1daff;
  --color-primary-8: #97c1ff;
  --color-primary-9: #CCEDFF;
  --color-primary-10: #A8E1AE;
  --color-primary-11: #a1c4f9;
  --color-primary-12: #F5F5F5;
  --color-light-2: #E0E0E0;
  --color-error: #e12f2f;
  --color-success: #66b032;
  --color-green: #569755;
  --color-green-2: #92e391;
  --color-green-3: #d3eace;
  --color-yellow: #e7d788;
  --color-yellow-2: #ffc247;
  --color-yellow-3: #8f4f00;
  --color-light-red: #FFE8E8;
  --color-deep-red: #9f0000;
  --color-red: #c43c2d;
  --color-red-2: #af2415;
  --color-grey: #b3b3c5;
  --color-grey-2: #9898AB;
  --color-grey-3: #e0e9f3;
  --color-grey-4: #D1D1D1;
  --color-grey-5: #EBEBF5;
  --color-table-grey: #fafafc;
  --color-table-grey-1: #f4f4fc;
  --color-dark: #4a4a68;
  --color-dark-2: #1a1a42;
  --color-dark-3: #696365;
  --color-dark-4: #60607A;
  --color-dark-6: #2a2828;
  --color-admin: #112855;
  --color-admin-2: #071530;
  --color-admin-3: #020710;
  --color-disabled: #C0C0C0;
  --color-light-blue: #EBF2FF;
  --color-light-blue-2: #D4E5FF;
  --color-light-blue-3: #E7F3FE;
  --color-dark-yellow: #7E6E1F;
  --color-light-brown: #f4f5f6;
  --color-light-green: #E4FFEC;
  --color-light-yellow: #FFF5D7;
  --color-light-grey: #F3F3FF;
  --color-sell-main: #001432;
  --color-sell-2: #5F5F61;
  --color-moneyex-primary: #25C900;
  --color-moneyex-primary-2: #6bf04d;
  --color-moneyex-primary-3: #305627;
  --color-moneyex-primary-4: #0a2404;
  --default-font-size: 1.8rem;
  --default-font-h1: 6.4rem;
  --default-font-h2: 4rem;
  --default-font-h3: 3.2rem;
  --default-font-subtitle: 2.4rem;
  --default-font-medium: 1.6rem;
  --default-font-small: 1.4rem;
  --default-font-xsmall: 1.2rem;
}

.ImageSlider_slide__bngdC {
  position: relative;
}
.ImageSlider_slide__img__gZ3qb {
  width: 100%;
  height: 100%;
  animation: ImageSlider_fade__vqWzd 8s;
}

@keyframes ImageSlider_fade__vqWzd {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.ImageSlider_leftarr__eUkCm {
  position: absolute;
  top: 50%;
  left: -10rem;
  font-size: 4.5rem;
  color: rgba(74, 74, 104, 0.1);
  cursor: pointer;
  z-index: 2;
}
.ImageSlider_leftarr__eUkCm:hover {
  color: rgba(74, 74, 104, 0.7);
}

.ImageSlider_rightarr__OV3YR {
  position: absolute;
  top: 50%;
  right: -10rem;
  font-size: 4.5rem;
  color: rgba(74, 74, 104, 0.1);
  cursor: pointer;
  z-index: 2;
}
.ImageSlider_rightarr__OV3YR:hover {
  color: rgba(74, 74, 104, 0.7);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables/_variables.scss","webpack://./src/assets/styles/ImageSlider.module.scss"],"names":[],"mappings":"AAAA;EAEC,sBAAA;EACA,sBAAA;EAEA,wBAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,wBAAA;EAGA,sBAAA;EACA,wBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EACA,oBAAA;EACA,sBAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EAEA,sBAAA;EACA,wBAAA;EACA,wBAAA;EAEA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EAEA,gCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EAKA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,+BAAA;EACA,6BAAA;EACA,4BAAA;EACA,6BAAA;ACbD;;AA9DA;EACE,kBAAA;AAiEF;AA/DE;EACE,WAAA;EACA,YAAA;EACA,qCAAA;AAiEJ;;AA7DA;EACE;IACE,UAAA;EAgEF;EA9DA;IACE,UAAA;EAgEF;AACF;AA7DA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;EACA,UAAA;AA+DF;AA7DE;EACE,6BAAA;AA+DJ;;AA3DA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;EACA,UAAA;AA8DF;AA5DE;EACE,6BAAA;AA8DJ","sourcesContent":[":root {\n\t//COLORS\n\t--color-light: #f4f9ff;\n\t--color-white: #ffffff;\n\n\t--color-primary: #1f68d6;\n\t--color-primary-2: #3b7ee3;\n\t--color-primary-3: #ccedff;\n\t--color-primary-4: #003c97;\n\t--color-primary-7: #c1daff;\n\t--color-primary-8: #97c1ff;\n\t--color-primary-9: #CCEDFF;\n\t--color-primary-10: #A8E1AE;\n\t--color-primary-11: #a1c4f9;\n\t--color-primary-12: #F5F5F5;\n\t--color-light-2: #E0E0E0;\n\n\n\t--color-error: #e12f2f;\n\t--color-success: #66b032;\n\t--color-green: #569755;\n\t--color-green-2: #92e391;\n\t--color-green-3: #d3eace;\n\t--color-yellow: #e7d788;\n\t--color-yellow-2: #ffc247;\n\t--color-yellow-3: #8f4f00;\n\t--color-light-red: #FFE8E8;\n\t--color-deep-red: #9f0000;\n\t--color-red: #c43c2d;\n\t--color-red-2: #af2415;\n\n\t--color-grey: #b3b3c5;\n\t--color-grey-2: #9898AB;\n\t--color-grey-3: #e0e9f3;\n\t--color-grey-4: #D1D1D1;\n\t--color-grey-5: #EBEBF5;\n\t--color-table-grey: #fafafc;\n\t--color-table-grey-1: #f4f4fc;\n\n\t--color-dark: #4a4a68;\n\t--color-dark-2: #1a1a42;\n\t--color-dark-3: #696365;\n\t--color-dark-4: #60607A;\n\t--color-dark-6: #2a2828;\n\n\t--color-admin: #112855;\n\t--color-admin-2: #071530;\n\t--color-admin-3: #020710;\n\n\t--color-disabled: #C0C0C0;\n\t--color-light-blue: #EBF2FF;\n\t--color-light-blue-2: #D4E5FF;\n\t--color-light-blue-3: #E7F3FE;\n\n\t--color-dark-yellow: #7E6E1F;\n\t--color-light-brown: #f4f5f6;\n\t--color-light-green: #E4FFEC;\n\t--color-light-yellow: #FFF5D7;\n\t--color-light-grey: #F3F3FF;\n\t--color-sell-main: #001432;\n\t--color-sell-2: #5F5F61;\n\n\t--color-moneyex-primary: #25C900;\n\t--color-moneyex-primary-2: #6bf04d;\n\t--color-moneyex-primary-3: #305627;\n\t--color-moneyex-primary-4: #0a2404;\n\n\n\n\t// FONT\n\t--default-font-size: 1.8rem;\n\t--default-font-h1: 6.4rem;\n\t--default-font-h2: 4rem;\n\t--default-font-h3: 3.2rem;\n\t--default-font-subtitle: 2.4rem;\n\t--default-font-medium: 1.6rem;\n\t--default-font-small: 1.4rem;\n\t--default-font-xsmall: 1.2rem;\n}\n\n//COLORS\n$color-light: #f4f9ff;\n$color-white: #ffffff;\n\n$color-primary: #1f68d6;\n$color-primary-2: #3b7ee3;\n$color-primary-3: #ccedff;\n$color-primary-4: #003c97;\n$color-primary-7: #c1daff;\n$color-primary-09: #CCEDFF;\n\n$color-error: #e12f2f;\n$color-success: #66b032;\n$color-green: #569755;\n$color-green-2: #92e391;\n$color-yellow: #e7d788;\n$color-light-red: #f7d1cd;\n\n$color-grey: #b3b3c5;\n$color-grey-2: #d1d1d1;\n$color-grey-3: #e0e9f3;\n$color-grey-4: #D1D1D1;\n\n$color-dark: #4a4a68;\n$color-dark-3: #696365;\n$color-dark-6: #2a2828;\n\n// FONT\n$default-font-size: 1.8rem;\n$default-font-h1: 6.4rem;\n$default-font-h2: 4rem;\n$default-font-h3: 3.2rem;\n$default-font-subtitle: 2.4rem;\n$default-font-small: 1.4rem;\n\n// SHADOWS\n$shadow-dark: 0 2rem 6rem rgba(0, 0, 0, 0.3);\n$shadow-light: 0 2rem 5rem rgba(0, 0, 0, 0.06);","@import \"./variables/variables\";\n\n.slide {\n  position: relative;\n\n  &__img {\n    width: 100%;\n    height: 100%;\n    animation: fade 8s;\n  }\n}\n\n@keyframes fade {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.leftarr {\n  position: absolute;\n  top: 50%;\n  left: -10rem;\n  font-size: 4.5rem;\n  color: rgba($color-dark, 0.1);\n  cursor: pointer;\n  z-index: 2;\n\n  &:hover {\n    color: rgba($color-dark, 0.7);\n  }\n}\n\n.rightarr {\n  position: absolute;\n  top: 50%;\n  right: -10rem;\n  font-size: 4.5rem;\n  color: rgba($color-dark, 0.1);\n  cursor: pointer;\n  z-index: 2;\n\n  &:hover {\n    color: rgba($color-dark, 0.7);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slide": `ImageSlider_slide__bngdC`,
	"slide__img": `ImageSlider_slide__img__gZ3qb`,
	"fade": `ImageSlider_fade__vqWzd`,
	"leftarr": `ImageSlider_leftarr__eUkCm`,
	"rightarr": `ImageSlider_rightarr__OV3YR`
};
export default ___CSS_LOADER_EXPORT___;
